import React from "react";
import { PiInfoThin } from "react-icons/pi";
import { useState } from "react";



const plans = [
  {
    name: "Demo",
    price: "Free",
    color: "bg-blue-600",
    features: [
      "Free Access",
      "No Earning",
      "30 days Validity",
      "Demo Surveys",
      "Customer Support",
    ],
    button: "Get Android App",
    button2: "Get IOS App",
  },
  {
    name: "Lite",
    price: "₹599",
    tag: "Best Value",
    offer: "Offer Price",
    refundText: "Refundable\nIncluding Taxes",
    notice:
      "The ₹6999 plan starts with paying only ₹599.The remaining amount will be deducted from your earnings.You can also pay the total amount and start withdrawing immediately.",
    note: "Note: This fee is to access all the paid features and will be refunded when you earn 35,000Rs",
    color: "bg-emerald-700",
    features: [
      "Lifetime Validity",
      "Unlimited Earning",
      "Unlimited Surveys",
      "Work 24 Hrs",
      "1600 Surveys = 80 Coins (80Rs)",
      "1 Coin = 1 Rupee",
      "Customer Support",
      "Unlock Full Access to www.techaircraft.com (Educational courses, Study materials and OTT Platforms) — Absolutely FREE!",
      "Special discount’s just for you — don’t miss out!"
    ],
    button: "Get Android App",
    button2: "Get IOS App",
  },
  {
    name: "Standard",
    price: "₹999",
    tag: "Best Value",
    offer: "Offer Price",

    refundText: "Refundable\nIncluding Taxes",
    notice:
      "The ₹9999 plan starts with paying only ₹999.The remaining amount will be deducted from your earnings.You can also pay the total amount and start withdrawing immediately",
    note: "Note: This fee is to access all the paid features and will be refunded when you earn 35,000Rs",
    color: "bg-violet-700",
    features: [
      "Lifetime Validity",
      "Unlimited Earning",
      "Unlimited Surveys",
      "Work 24 Hrs",
      "1000 Surveys = 80 Coins (80Rs)",
      "1 Coin = 1 Rupee",
      "Customer Support",
      "Unlock Full Access to www.techaircraft.com (Educational courses, Study materials and OTT Platforms) — Absolutely FREE!",
      "Special discount’s just for you — don’t miss out!"
    ],
    button: "Get Android App",
    button2: "Get IOS App",
  },
  {
    name: "Premium",
    price: "₹3,999",
    tag: "Best Value",
    offer: "Offer Price",

    refundText: "Refundable\nIncluding Taxes",
    note: "Note: This fee is to access all the paid features and will be refunded when you earn 35,000Rs",
    color: "bg-amber-500",
    features: [
      "Lifetime Validity",
      "Unlimited Earning",
      "Unlimited Surveys",
      "Work 24 Hrs",
      "2000 Surveys = 80 Coins (80Rs)",
      "1 Coin = 1 Rupee",
      "Instant withdrawal",
      "Customer Support",
      "Unlock Full Access to www.techaircraft.com (Educational courses, Study materials and OTT Platforms) — Absolutely FREE!",
      "Special discount’s just for you — don’t miss out!"
    ],
    button: "Get Android App",
    button2: "Get IOS App",
  },
];



const PricingPlans = () => {
    const [gstInfoOpen, setGstInfoOpen] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
  //   const amount = 499;
  // const security_amount = amount;
  // const service_charge = amount * 0.1;
  // const gst_amount = (amount + service_charge) * 0.18;
  const getAmountNumber = (price) =>
  Number(price.replace(/[₹,]/g, "")) || 0;

const amount = selectedPlan ? getAmountNumber(selectedPlan.price) : 0;

const service_charge = amount * 0.1;
const gst_amount = ( service_charge) * 0.18;
const security_amount = amount - (service_charge + gst_amount) ;
  return (
    <section className=" bg-gray-100  px-4 py-16">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold font-sans mb-4">
          Choose Your{" "}
          <span className="text-green-500"> Premium and Start Earning!</span>
        </h1>
      </div>

      <div className="flex max-w-90vw flex-col md:flex-row mx-auto justify-center gap-6 p-6 bg-gray-100 max-h-fit  ">
        {plans.map((plan, idx) => (
          <div
            key={idx}
            className={`relative w-full md:w-1/4 rounded-2xl shadow-lg overflow-hidden ${plan.color} text-white flex flex-col`}
          >
            <div className="p-5 font-sans h-44 sm:h-44 lg:h-44 flex flex-col justify-between relative">
              <h2 className="text-2xl font-bold font-serif">{plan.name}</h2>
              <h3 className="text-3xl flex items-center gap-2 font-semibold mt-2 font-serif">
                {plan.price}{" "}
                <div>
                  {" "}
                  {plan.offer && (
                    <span className="text-xs text-white font-sans bg-green-600 rounded-sm p-1">
                      {plan.offer}
                    </span>
                  )}
                </div>
              </h3>
              {plan.refundText && (
                // <p className="text-lg whitespace-pre mt-1 font-serif text-white/80">
                //   {plan.refundText}
                
                // </p>
                <p className="text-lg mt-1 font-serif text-white/80 leading-snug">
    <span className="flex items-center gap-1">
      <span>Refundable</span>
      <PiInfoThin
  size={14}
  onClick={() => {
    setSelectedPlan(plan);
    setGstInfoOpen(true)
  }}
  className="cursor-pointer text-white/80 hover:text-white"
/>
    </span>

    <span className="block whitespace-pre">
      {plan.refundText.replace("Refundable\n", "")}
    </span>
  </p>
              )}

              {plan.tag && (
                <div className="absolute top-5 -right-10 w-32 bg-white text-green-700 text-xs font-medium py-1 text-center rotate-45 shadow-md">
                  {plan.tag}
                </div>
              )}
            </div>

            <div className="bg-white text-black px-5 py-4 flex-1 flex flex-col justify-between">
              <ul className="mb-4">
                {plan.notice && (
                  <div className="p-2 bg-gray-100 rounded-lg mb-3">
                    <p className="text-xs text-gray-700 mb-2 font-sans">
                      {plan.notice}
                    </p>
                  </div>
                )}
                <h2 className="text-black font-semibold mt-2 font-sans mb-3 text-lg">
                  Features
                </h2>

                {/* {plan.features.map((feature, i) => (
                  <li key={i} className="flex font-sans items-start gap-2 mb-2">
                    <span className="text-blue-600">➤</span>
                    <span>
                      {feature.includes("www.techaircraft.com") ? (
                        <>
                          {feature.split("www.techaircraft.com")[0]}
                          <a
                            href="https://techaircraft.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 underline hover:text-blue-700"
                          >
                            www.techaircraft.com
                          </a>
                          {feature.split("www.techaircraft.com")[1]}
                        </>
                      ) : (
                        feature
                      )}
                    </span>
                  </li>
                ))} */}
               {plan.features.map((feature, i) => {
                let processedFeature = feature;

                // Replace www.techaircraft.com with clickable link
                processedFeature = processedFeature.replace(
                  /www\.techaircraft\.com/g,
                  `<a href="https://techaircraft.com" target="_blank" rel="noopener noreferrer" class="text-blue-500 underline hover:text-blue-700">www.techaircraft.com</a>`
                );

                // Highlight "Absolutely FREE!" text
                processedFeature = processedFeature.replace(
                  /Absolutely FREE!/g,
                  `<span class="text-green-600 font-extrabold bg-green-100 px-2 py-0.5 rounded-lg shadow-sm">Absolutely FREE!</span>`
                );

                  const isAccessLine = feature.includes("www.techaircraft.com");

  // Choose icon based on condition
  const icon = isAccessLine
    ? `<span class='text-yellow-500 text-lg'>🚀</span>` // special for access line
    : `<span class='text-blue-600 text-lg'>➤</span>`;

                return (
                  <li
                    key={i}
                    className="flex font-sans items-start gap-2 mb-2"
                    dangerouslySetInnerHTML={{
                      __html: `${icon}<span>${processedFeature}</span>`,
                    }}
                  />
                );
              })}




              </ul>

              {plan.note && (
                <div className="p-2 border-2 mt-auto border-gray-300 rounded-lg mb-2">
                  <p className="text-xs text-gray-500 mb-3 font-sans">
                    {plan.note}
                  </p>
                </div>
              )}
              <div className="flex flex-col gap-2">
                <a href="https://play.google.com/store/apps/details?id=com.techaircraft.surveyiq&pcampaignid=web_share">
                  <button className="w-full bg-green-500 text-white py-2 rounded-full hover:bg-green-600">
                    {plan.button}
                  </button>
                </a>
                <a href="https://surveysiq.com/ ">
                  <button className="w-full bg-green-500 text-white py-2 rounded-full hover:bg-green-600">
                    {plan.button2}
                  </button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      {gstInfoOpen && (
   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 relative">
      <div className="w-full p-5 bg-bgBlue text-black">
        <div className="font-bold text-lg">₹{amount}</div>

        <div>Security → ₹{security_amount.toFixed(2)}</div>
        <div>Service charge 10% → ₹{service_charge.toFixed(2)}</div>
        <div>GST 18% → ₹{gst_amount.toFixed(2)}</div>

        <br />

        <div className="text-sm opacity-90 leading-relaxed">
          Security amount is collected as a refundable security deposit and is adjusted as part of payout as per Refund Policy. Refund and payout are subject to platform policies and user compliance.
        </div>

        <br />

        <div className="flex justify-end ">
          <button
           className="mt-5 w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
            onClick={() => setGstInfoOpen(false)}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </section>
  );
};

export default PricingPlans;
